export default {
  appInfo: {
    // TODO: Translate (PWA)
    state: {
      configuration: 'Configuración',
      downloaded: 'Descargado',
      heading: 'Información del estado de solicitud',
      lastUpdated: 'Última actualización',
      noConfiguration: 'No hay configuración disponible',
      questionsAnswered: 'Ninguna pregunta contestada | {n} pregunta contestada | {n} preguntas contestadas',
      storedResponses: 'Respuestas de la encuesta archivadas',
      surveyDetails: 'Datos de la encuesta',
      surveyInProgress: 'Actualmente se está realizando una encuesta',
      surveyNotInProgress: 'Actualmente no se está realizando una encuesta',
      surveyProgress: 'Progreso de la encuesta',
      surveysAvailable: 'No hay encuestas disponibles | {n} encuesta disponible | {n} encuestas disponibles',
      surveysStored: 'No hay respuestas en espera de ser cargadas | {n} respuesta en espera de ser cargada | {n} respuestas en espera de ser cargadas',
      updateAvailable: 'Actualización disponible',
      updateDownloading: 'Actualización en descarga'
    },
    version: 'Versión de la aplicación',
    sinceConfigUpdate: 'Not Implemented.',
    sinceSurveyUpload: 'Not Implemented.',
    sinceSurveyUploadYesterday: 'Not Implemented.',
    sinceMenuItemUpdate: 'Not Implemented.',
    appUpdated: 'Not Implemented.',
    install: {
      install: 'Not Implemented.',
      installTitle: 'Not Implemented.',
      installDesc: 'Not Implemented.',
      installInstructionsDesc: 'Not Implemented.',
      installInstructionsLabel: 'Not Implemented.',
      appInstalled: 'Not Implemented.',
      appInstalledDesc: 'Not Implemented.',
      iosPressShareButton: 'Not Implemented.',
      iosPressAddToHomescreen: 'Not Implemented.',
      unsupportedDeviceTitle: 'Not Implemented.',
      unsupportedDeviceDesc: 'Not Implemented.',
      unsupportedBrowserTitle: 'Not Implemented.',
      unsupportedBrowserDesc: 'Not Implemented.',
      pressMenuIcon: 'Not Implemented.',
      chromePressInstallApp: 'Not Implemented.',
      samsungPressAddPageTo: 'Not Implemented.',
      samsungPressHomeScreen: 'Not Implemented.',
      safari: 'Not Implemented.',
      samsungInternet: 'Not Implemented',
      chrome: 'Not Implemented.'
    }
  }
};